<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="guiaRecebimentoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ apenas_protocolo ? 'Gerar Protocolo' : ( envio ? 'Protocolo de Envio da Recepção' : 'Protocolo de Entrega de Guias' ) }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="guias">
            <h2
              class="text-primary"
            >{{ guias.length }} {{ guias.length > 1 ? 'guias selecionadas' : 'guia selecionada' }}</h2>
            <p>{{ periodo }}</p>

            <h3 class="mt-2">Confirma {{ apenas_protocolo ? 'gerar o protocolo de fatura' : ( envio ? 'o envio' : 'a entrega' ) }} das guias?</h3>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <az-submit @click="receber ()">Confirmar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="recebimentoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Protocolo Gerado</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="recebimento">
            <p>Número do Protocolo:</p>
            <h2 class="text-primary">{{ recebimento.st_protocolo }}</h2>
            <h4 class="text-dark">P{{ recebimento.id_recebimento }}</h4>
            <p>
              {{ recebimento.guia_recebimentos.length }}
              {{ recebimento.guia_recebimentos.length > 1 ? 'guias entregues' : 'guia entregue' }}
            </p>

            <div class="list-group mt-3" v-if="relatorios && relatorios.length && recebimento">
                <button
                    v-for="(relatorio, irx) in relatorios" :key="'r' + irx"
                    @click="abrir_relatorio({ name: 'relatorio', 
                        params: { 
                            id: relatorio.id, 
                            protocolo_id: recebimento.id_recebimento, 
                            guia_id: recebimento.guia_recebimentos.map(item => item.id_guia),
                            breadcrumb: $store.state.breadcrumb, linked: true, backlink: $route.path 
                        } 
                    })"
                    class="list-group-item list-group-item-action">
                    <i class="fa-solid fa-print fa-fw mr-3"></i>
                    {{ relatorio.title }}
                </button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <button type="button" class="btn btn-success" @click="imprimir()">Imprimir</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Consultar Protocolos -->
    <div class="modal fade" id="consultarProtocoloModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Protocolos</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <az-empty-state v-if="!lista || !lista.data.length" />

            <template v-else>

                <div class="mb-3" v-if="!apenas_protocolo || apenas_do_protocolo">
                    <az-input
                        sizing="sm"
                        label="Apenas guias que estão no protocolo"
                        type="checkbox-group"
                        v-model="apenas_do_protocolo" />
                </div>
              
                <span class="badge badge-secondary mb-3" v-if="( lista && lista.last_page > 1 )">
                    {{ lista.from }} - {{ lista.to }}  / {{ lista.total }}
                </span>

                <div class="list-group">
                    <li class="list-group-item d-flex justify-content-between" v-for="(receb, irx) in lista.data" :key="irx">
                    <a href="#" @click.prevent="selecionar(receb)" class="card-link">
                        <span class="badge badge-secondary mr-2">
                        {{ receb.guia_recebimentos_count }}
                        </span>
                        {{ $util.getFormatDate(receb.dt_recebimento) }}
                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                        P{{ receb.id_recebimento }}
                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                        {{ receb.st_protocolo }} 
                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                        {{ receb.usuario.st_login }} 
                    </a>

                    <div v-if="callback_buscar">
                        <a href="#" @click.prevent="callback_buscar(receb)" class="card-link">
                        <i class="fa fa-search" aria-hidden="true"></i>
                        </a>
                    </div>
                    </li>
                </div>

            </template>

            <pre v-if="false">{{ lista }}</pre>
          </div>
          <div class="modal-footer">

            <template v-if="lista && lista.last_page > 1">

                <div class="d-flex">
                    <paginate
                        class="mb-0"
                        :page-count="lista.last_page"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-link'"
                        :next-class="'page-link'"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :click-handler="paginar">
                    </paginate>
                </div>
                
            </template>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Imprimir Protocolo -->
    <div id="print" v-show="false">
      <ProtocoloEntregaGuia
        ref="protocoloEntrgaRef"
        :recebimento="recebimento"
        :periodo="periodo"
        :guias="guias"
      />
    </div>
    
  </div>
</template>

<script>
import _ from "lodash";
import * as moment from "moment";
import $ from "jquery";
import AzSubmit from "../../util/AzSubmit.vue";
import ProtocoloEntregaGuia from "../../relatorios/faturamento/ProtocoloEntregaGuia";
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
  data() {
    return {
      guias: null,
      recebimento: null,
      lista: null,
      filtros: {}, 
      apenas_protocolo: false,
      apenas_do_protocolo: false, 
    };
  },

  components: {
    AzSubmit,
    ProtocoloEntregaGuia,
    AzEmptyState,
    AzInput, 
  },

  props: ['envio', 'callback_buscar', 'relatorios'],

  computed: {
    periodo: function() {
      if (!this.guias) return;

      let inicio = _.minBy(this.guias, item => {
        return item.dt_criacao.substr(0, 10);
      });

      let fim = _.maxBy(this.guias, item => {
        return item.dt_criacao.substr(0, 10);
      });

      return (
        "Período " +
        moment(inicio.dt_criacao.substr(0, 10), "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        ) +
        " a " +
        moment(fim.dt_criacao.substr(0, 10), "YYYY-MM-DD").format("DD/MM/YYYY")
      );
    }
  },

  methods: {
    abrir_relatorio (to) { 
        $(".modal").modal("hide");

        this.$root.$children[0].$refs.relatmodal.abrir(to.params);

        //this.$router.push(to);
    },

    selecionar(receb) { 
      let id_recebimento = receb.id_recebimento;
      this.lista = null;

      this.$util.load(this, { 
        service: 'recebimentos',
        parms: { 
          id_recebimento: id_recebimento,
        },
        loadTo: res => { 
            this.recebimento = _.first(res);
            this.guias = this.recebimento.guia_recebimentos.filter(item => ( !this.apenas_do_protocolo || item.guia.ch_status == 'PT' || item.guia.ch_status == 'PF' ))
                .map(item => item.guia);

            $("#consultarProtocoloModal").modal("hide");
            this.imprimir();
        }
      });
    },

    abrir(guias, apenas_protocolo = false) {
      this.guias = guias;
      this.apenas_protocolo = apenas_protocolo;
      $("#guiaRecebimentoModal").modal("show");
    },

    consultar(filtros) { 
      this.filtros = filtros

      this.lista = null;
      $("#consultarProtocoloModal").modal("show");

      this.$util.load(this, { 
        service: 'recebimentos',
        parms: { 
          ...filtros,
          size: 100, 
          page: 1, 
        },
        loadTo: res => { 
          this.lista = res;
        }
      });
    },

    paginar(page = 1) {
      this.$util.load(this, { 
        service: 'recebimentos',
        parms: { 
          ...this.filtros,
          size: 100, 
          page: page, 
        },
        loadTo: res => { 
          this.lista = res;
        }
      });
    },

    receber() {
      this.$store.commit("loading", true);

      let query = {
        q: [
          {
            name: "guias.receber",
            id: "recebimento",
            parms: { 
              qtd: this.guias.length, 
              guias: this.guias.map(item => { 
                return { 
                  id_guia: item.id_guia,
                  ch_status: item.ch_status, 
                };
              }),
              envio: this.envio,  
              apenas_protocolo: this.apenas_protocolo
            }
          }
        ]
      };

      this.axios
        .post("/aql", query)
        .then(res => {
          if (res.data.recebimento.status == 200) {
            this.$emit("refresh");
            $("#guiaRecebimentoModal").modal("hide");
            this.recebimento = res.data.recebimento.data;
            $("#recebimentoModal").modal("show");
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    },
    imprimir() {
      const grp = _.groupBy(this.guias, function(item) {
        return item.id_operadora;
      });

      const itemsExibicao = _.mapValues(grp, function(items) {
        return {
          total: _.sumBy(items, function(item) {
            return _.sumBy(item.atendimento_procedimento_guias, function(pg) {
              return parseFloat(pg.dc_valor);
            });
          }),
          guias: items
        };
      });

      this.$refs.protocoloEntrgaRef.agruparGuias(itemsExibicao);

      this.$nextTick(() => {
        const configPrint = {
          styles: [
            "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"
            // "landscape.css"
          ]
        };

        this.$htmlToPaper("print", configPrint, () =>
          console.log("printed...")
        );
      });
    }
  }
};
</script>